import { c as _c } from "react/compiler-runtime";
import { STORE_ITEM_CLASS_NAME } from 'modules/stores/store/constants/store-item-class-name';
import { twJoin, twMerge } from 'tailwind-merge';
const BASE_CLASS = 'animate-pulse bg-skeleton-primary text-transparent';
const ContentSkeleton = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = twMerge(STORE_ITEM_CLASS_NAME, "flex flex-col items-center gap-5 sm:items-start lg:flex-row");
    t1 = <div className={twJoin(BASE_CLASS, "h-32 w-32 shrink-0 rounded-full")}>.</div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-5"><div className={t0}>{t1}<div className="flex w-full flex-col gap-3"><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div></div></div><div className={twMerge(STORE_ITEM_CLASS_NAME, "flex flex-col gap-3")}><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div></div><div className={twMerge(STORE_ITEM_CLASS_NAME, "flex flex-col gap-3")}><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div><div className={twJoin(BASE_CLASS, "h-6 w-full rounded-md")}>.</div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default ContentSkeleton;